<template>
  <tr role="row">
    <th v-for="column in columns"
        :key="column.name"
        :aria-label="getColumnAriaLabel(column)"
        :class="getColumnClasses(column)"
        :style="{ width: column.width }"
        tabindex="0"
        rowspan="1"
        colspan="1"
        @click="onColumnClick(column)">{{ getColumnLabel(column) }}
    </th>
  </tr>
</template>

<script>
import sortingMixin from '../../mixins/sorting'

const snakeCase = require('to-snake-case')

export default {
  name: 'TableHeaderRow',
  mixins: [sortingMixin],
  props: {
    orderBy: {
      type: String | null,
      required: true
    },
    orderDirection: {
      type: String | null,
      required: true
    },
    translationPrefix: {
      type: String,
      required: true
    },
    columns: {
      // TableHeaderColumn[]
      type: Array,
      required: true
    }
  },
  methods: {
    snakeCaseKeys: (fieldName) => snakeCase(fieldName),
    getColumnAriaLabel (column) {
      if (column.sortable) {
        return `${this.getColumnLabel(column)}: activate to sort column ${this.getDestinationDirection(column.name)}`
      }

      return ''
    },
    getColumnClasses (column) {
      const classes = [this.snakeCaseKeys(column.name)]
      classes.push(column.sortable ? this.getRowHeaderSortingClass(column.name) : 'sorting_disabled')

      return classes
    },
    getColumnLabel (column) {
      return this.$t(column.label ? column.label : `${this.translationPrefix}${column.name}`)
    },
    onColumnClick (column) {
      if (column.sortable) {
        this.handleColumnHeaderClick(column.name)
      }
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/tableHeader/TableHeader.vue